"use client"

import type React from "react"
import { memo } from "react"
import type { FieldMapping } from "../../../types/field-mapping"

interface FieldMappingRowProps {
  mapping: FieldMapping
  hubspotFields: string[]
  salesforceFields: string[]
  onHubSpotFieldChange: (mappingId: string, newField: string) => void
  onSalesforceFieldChange: (mappingId: string, newField: string) => void
  onDelete: (mappingId: string) => void
}

const FieldMappingRow: React.FC<FieldMappingRowProps> = memo(
  ({ mapping, hubspotFields, salesforceFields, onHubSpotFieldChange, onSalesforceFieldChange, onDelete }) => (
    <div className="field-mapping-row">
      <div className="field-select-container">
        <select
          value={mapping.hubspotField}
          onChange={(e) => onHubSpotFieldChange(mapping.id, e.target.value)}
          className="field-select hubspot-field"
          aria-label="Select HubSpot field"
        >
          <option value="">Select HubSpot Field</option>
          {hubspotFields.map((field) => (
            <option key={field} value={field}>
              {field}
            </option>
          ))}
        </select>
      </div>

      <div className="mapping-arrow">→</div>

      <div className="field-select-container">
        <select
          value={mapping.salesforceField}
          onChange={(e) => onSalesforceFieldChange(mapping.id, e.target.value)}
          className="field-select salesforce-field"
          aria-label="Select Salesforce field"
        >
          <option value="">Select Salesforce Field</option>
          {salesforceFields.map((field) => (
            <option key={field} value={field}>
              {field}
            </option>
          ))}
        </select>
      </div>

      <button
        className="delete-mapping-btn"
        onClick={() => onDelete(mapping.id)}
        title="Delete mapping"
        aria-label="Delete field mapping"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="3,6 5,6 21,6" />
          <path d="M19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2" />
          <line x1="10" y1="11" x2="10" y2="17" />
          <line x1="14" y1="11" x2="14" y2="17" />
        </svg>
      </button>
    </div>
  ),
)

FieldMappingRow.displayName = "FieldMappingRow"

export default FieldMappingRow
